var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPep = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 15,
    rx: 7.5,
    stroke: "#00AABE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83175 9.0718H6.10973V7.8718H7.83175C8.09786 7.8718 8.31447 7.82394 8.48157 7.72821C8.64866 7.62906 8.77089 7.49231 8.84825 7.31795C8.92561 7.14359 8.96429 6.94701 8.96429 6.72821C8.96429 6.50599 8.92561 6.29915 8.84825 6.1077C8.77089 5.91624 8.64866 5.7624 8.48157 5.64616C8.31447 5.52992 8.09786 5.4718 7.83175 5.4718H6.59245V11.7333H5.19998V4.26667H7.83175C8.36089 4.26667 8.81421 4.37265 9.19173 4.58462C9.57233 4.79317 9.8632 5.08205 10.0643 5.45129C10.2655 5.82052 10.366 6.24274 10.366 6.71795C10.366 7.2 10.2655 7.6171 10.0643 7.96923C9.8632 8.32137 9.57233 8.59317 9.19173 8.78462C8.81421 8.97607 8.36089 9.0718 7.83175 9.0718Z",
    fill: "#00AABE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8617 10.5333V11.7333H12.2644V10.5333H15.8617ZM12.7193 4.26667V11.7333H11.3268V4.26667H12.7193ZM15.3929 7.3077V8.47693H12.2644V7.3077H15.3929ZM15.857 4.26667V5.4718H12.2644V4.26667H15.857Z",
    fill: "#00AABE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3057 9.0718H17.5837V7.8718H19.3057C19.5718 7.8718 19.7884 7.82394 19.9555 7.72821C20.1226 7.62906 20.2448 7.49231 20.3222 7.31795C20.3996 7.14359 20.4382 6.94701 20.4382 6.72821C20.4382 6.50599 20.3996 6.29915 20.3222 6.1077C20.2448 5.91624 20.1226 5.7624 19.9555 5.64616C19.7884 5.52992 19.5718 5.4718 19.3057 5.4718H18.0664V11.7333H16.6739V4.26667H19.3057C19.8348 4.26667 20.2882 4.37265 20.6657 4.58462C21.0463 4.79317 21.3371 5.08205 21.5383 5.45129C21.7394 5.82052 21.84 6.24274 21.84 6.71795C21.84 7.2 21.7394 7.6171 21.5383 7.96923C21.3371 8.32137 21.0463 8.59317 20.6657 8.78462C20.2882 8.97607 19.8348 9.0718 19.3057 9.0718Z",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPep);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pep.9efd24d0ebf16081f810e392dbce8c20.svg";